export default "__VITE_ASSET__DjILo56C__"